<template>
    
    <div class="columns is-marginless is-multiline">

        <!-- hidden button with shortcuts to zoom reviewables -->
        <button v-show=false v-shortkey="{out: ['-'], in: ['+']}" @shortkey="RevCardZoom"></button>
        <button v-show=false v-shortkey="{in: ['=']}" @shortkey="RevCardZoom"></button>

        <div class="column" v-bind:class="ColWidthClass"
            v-for="reviewable in reviewables"
            v-bind:key="reviewable.id"
        >
            <rev-card :reviewable="reviewable"></rev-card>
        </div>
    </div>

</template>


<script>
    export default {
        data() {
            return {
                // column size
                col_count : 3
            }
        },
        props: {
            reviewables : Array,
        },
        computed: {
            ColWidthClass: function() {
                // clamp the column count
                this.col_count = Math.min(Math.max(this.col_count, 1), 5)

                // 0 doesnt apply
                let classes = ['', 'is-full', 'is-half', 'is-one-third', 'is-one-quarter',  'is-one-fifth']

                return {
                    [classes[this.col_count]] : true
                }
            }
        },
        methods: {
            RevCardZoom (event) {
                // simon likes this switch its quite pythonic, zoom 'in' or 'out'
                switch (event.srcKey) {
                    case 'out':
                        this.col_count += 1
                        break
                    case 'in':
                        this.col_count -= 1
                        break
                }
            },
        },
        created() {
        },
    }

</script>


<style scoped lang="scss">
</style>
